import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { createPortal } from 'react-dom';
import React, { useCallback } from 'react';

import {
  removeNotification,
  INotification,
} from 'store/notifications/NotificationsSlice';
import { RootState } from 'store/store';

import ToastList from 'components/ToastList';
import { appDispatch } from 'store/store';

const container = document.getElementById('notifications');
if (!container) {
  throw new Error('please add a div on index.html with `notifications` id');
}

type StateToProps = {
  notifications: INotification[];
};

type DispatchToProps = {
  removeNotification: (id: string) => void;
};

type ComponentProps = StateToProps & DispatchToProps;

const Notifications: React.FC<ComponentProps> = ({
  notifications,
  removeNotification,
}: ComponentProps) => {
  const handleClose = (id: string) => {
    return removeNotification(id);
  };
  const handleCloseCallback = useCallback(handleClose, []);

  return createPortal(
    <ToastList data={notifications} onCloseToast={handleCloseCallback} />,
    container
  );
};

const mapStateToProps: MapStateToProps<StateToProps, unknown, RootState> = (
  state
) => ({
  notifications: state.notifications,
});

const mapDispatchToProps: MapDispatchToProps<DispatchToProps, unknown> = () => {
  return {
    removeNotification: (id: string) =>
      appDispatch(removeNotification(id) as any),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
